// The brand this build was made for (brands.js, picked by VUE_APP_BRAND), put in by the build.
export type Brand = {
  key: string;
  name: string;
  provider: string | null;
  title: string;
  logo: string;
  whatsapp: string | null;
  whatsappLabel: string | null;
  termsUrl: string;
  siteUrl: string;
};

const brand: Brand = process.env.__BRAND__ as unknown as Brand;
export default brand;
